import { APIMethod, fetchData } from "@client";

export async function checkProjectCommentsQuery(projectUuid) {
  const res = await fetchData(`/v1/ws/project/comments/has/${projectUuid}`,
    APIMethod.GET,
  );
  return res?.hasComments;
}
